module.exports = {"id":"203622","name":"Evgeniy Gorodov","rating":"72","photo":"./data/images/photos/1/203622.png","club":{"name":"Terek Grozny","logo":"./data/images/clubs/TerekGrozny.png"},"positions":["G"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/EvgeniyGorodov0.json
// module id = 1312
// module chunks = 0